export default __webpack_public_path__ + "static/media/KZ.T.10.0737 black.d000cdae.svg";